import { Button } from 'components';
import { ButtonProps } from 'components/atoms/Button/Button';
import { LogoutIcon } from 'components/icons';
import { memo, PropsWithChildren } from 'react';
import classes from 'classnames';
import styles from './LogoutButton.module.scss';

export default memo(function LogoutButton({
  className,
  ...props
}: PropsWithChildren<ButtonProps>) {
  return (
    <Button
      dataTest="logout-btn"
      rightIcon={<LogoutIcon />}
      {...props}
      className={classes(
        className,
        styles['logout-button'],
        styles['logout-icon'],
      )}
    />
  );
});
